// extracted by mini-css-extract-plugin
module.exports = {"pointsSummary":"points-summary_pointsSummary__BPJS4","pointsCounter":"points-summary_pointsCounter__Wwt_t"};